export default "__VITE_ASSET__oluM0$RF__"